import { action, observable } from "mobx";
import { RouterStore } from "mobx-react-router";
import { message } from "antd";
import * as React from "react";
import { ArgsProps } from "antd/lib/message";

import RootStore from "./RootStore";

export interface AlertInterface {
  title: string;
  message?: React.ReactNode;
  confirmMessage?: string;
  cancelMessage?: string;
  customMessage?: string;
  isNegative?: boolean;
  isError?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  onCustom?: () => void;
}

export interface PromptInterface {
  title: string;
  message?: string;
  initialValue?: string;
  hintText?: string;
  validator?: (value: string) => boolean;
  confirmMessage?: string;
  cancelMessage?: string;
  onConfirm: (value: string) => void;
  onCancel?: () => void;
}

export interface ToastOptionInterface {
  duration?: number;
  type: ArgsProps["type"];
  content?: React.ReactNode;
  icon?: React.ReactNode;
}

export default class PageStore {
  @observable public isSpinnerShow: boolean = false;
  @observable public spinnerMessage?: string;
  @observable public isAlertShow: boolean;
  @observable public alert: AlertInterface;
  @observable public isPromptShow: boolean;
  @observable public prompt: PromptInterface;
  @observable public toastOptions: ToastOptionInterface;
  @observable public rootContainer: () => HTMLElement;

  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.rootContainer = () => document.getElementById("main")!;
  }

  @action.bound
  public openSpinner(content?: string) {
    this.isSpinnerShow = true;
    this.spinnerMessage = content;
  }

  @action.bound
  public closeSpinner() {
    this.isSpinnerShow = false;
  }

  @action.bound
  public openAlert(options?: AlertInterface) {
    this.isAlertShow = true;
    if (options) {
      this.alert = options;
    }
  }

  @action.bound
  public closeAlert() {
    this.isAlertShow = false;
  }

  @action.bound
  public openPrompt(options?: PromptInterface) {
    this.isPromptShow = true;
    if (options) {
      this.prompt = options;
    }
  }

  @action.bound
  public closePrompt() {
    this.isPromptShow = false;
  }

  @action.bound
  public openToast(content: string, options?: ToastOptionInterface) {
    const duration = options && options.duration ? options.duration / 1000 : 3;
    setTimeout(() => {
      message.open({
        content,
        duration,
        type: options ? options.type : ("info" as ArgsProps["type"]),
        ...options,
      });
    }, 100);
  }

  @action.bound
  public openPage(
    address: string,
    e?: React.MouseEvent<
      HTMLTableRowElement | HTMLDivElement | HTMLButtonElement
    >,
  ) {
    if (e && (e.metaKey || e.ctrlKey)) {
      window.open(address, "_blank");
    } else {
      this.rootStore.routerStore.push(address);
    }
  }

  @action.bound
  public replacePage(address: string) {
    this.rootStore.routerStore.replace(address);
  }
}
